// src/import/geo/initGeoHeaders.js
// Gets browser geolocation once, caches to localStorage, and keeps a tiny
// in-memory copy so your axios interceptor can attach headers immediately.

const GEO_LS_KEY = "geo_headers_cache";

export const getCachedGeo = () => {
  try {
    return JSON.parse(localStorage.getItem(GEO_LS_KEY)) || {};
  } catch {
    return {};
  }
};

export const setCachedGeo = (geo) => {
  try {
    localStorage.setItem(GEO_LS_KEY, JSON.stringify(geo || {}));
  } catch {}
};

export async function initGeoHeaders() {
  // If we already have a recent cache, keep it; still try to refresh in background.
  const cached = getCachedGeo();
  if (!cached.lat || !cached.lng) {
    setCachedGeo({ ...cached, lat: null, lng: null });
  }

  if (!("geolocation" in navigator)) return;

  // non-blocking refresh attempt
  navigator.geolocation.getCurrentPosition(
    (pos) => {
      const { latitude, longitude } = pos.coords || {};
      // You can also fill city/state if you have your own reverse-geocode endpoint.
      const next = {
        lat: latitude ?? null,
        lng: longitude ?? null,
        city: cached.city || "", // optional: set via your own API
        state: cached.state || "", // optional: set via your own API
      };
      setCachedGeo(next);
    },
    () => {
      // ignore errors; headers just won't include coords
    },
    { enableHighAccuracy: true, timeout: 10000, maximumAge: 600000 } // 10s / 10min cache
  );
}
